import { ShortDataModel, RoleModel, InterfaceElementModel } from 'Models'
import { intersection } from 'lodash'
import { Roles } from 'Src/constants/Roles'
import { NEED_ADD_PROPS_CHANNEL_NAME, PARAMS_IS_CHECK_PARTNER_PAYMENT } from 'Constants/Global'

const findNavElement = (structure: InterfaceElementModel[], url: string): InterfaceElementModel =>
	structure.find((s): boolean => s.url === url)

export const searchBaseFrontUrlName = (structure: InterfaceElementModel[], url: string): string => {
	if (!url || !url.length) return ''
	const splitUrl = url.split('/')
	const res = findNavElement(structure, splitUrl.join('/'))
	if (res && res.name) {
		return res.name
	}
	splitUrl.pop()
	return searchBaseFrontUrlName(structure, splitUrl.join('/'))
}

export const getUserRolesSlugsHelper = (roles?: RoleModel[]) => roles?.map((item) => item.slug)

export const isShortDataArrayHasSlugHelper = (array: ShortDataModel[], target: string) => {
	if (!array) return false
	return array.some(({ slug }) => slug === target)
}

export class AccessCheck {
	private userRoles: RoleModel[]
	public constructor(userRoles: RoleModel[]) {
		this.userRoles = userRoles
	}
	private getUserRolesSlugs = (): string[] =>
		this.userRoles.map((item: RoleModel): string => item.slug)
	public hasRole = (roles: Roles[]): boolean =>
		!!intersection(roles, this.getUserRolesSlugs()).length
}

export const hasAddedProps = (
	channels,
	{ oktmo, payment_account, kbk, name_for_payment },
	isCanEdit?: boolean
): boolean => {
	return (
		channels.some(({ order_prefix }): boolean =>
			NEED_ADD_PROPS_CHANNEL_NAME.includes(order_prefix)
		) &&
		(isCanEdit || !oktmo || !payment_account || !kbk || !name_for_payment)
	)
}

export const isChecked = ({
	kpp,
	incorporation_form,
	partner_type: { slug },
	taxation_form_id,
	bik,
	checking_account,
}): boolean => {
	return (
		(!kpp && incorporation_form?.kind === PARAMS_IS_CHECK_PARTNER_PAYMENT.KIND) ||
		(slug === PARAMS_IS_CHECK_PARTNER_PAYMENT.PARTNER_TYPE && !taxation_form_id) ||
		!bik ||
		!checking_account
	)
}
